import { useEffect, useRef, useState } from 'react';

import { useRedirect } from './use-redirect';

export const useRedirectTimer = ({ to, delay: initialDelay }) => {
  const [delay, setDelay] = useState(initialDelay);
  const redirect = useRedirect();
  const timeoutId = useRef();

  useEffect(() => {
    if (delay <= 0) {
      redirect(to);
    } else {
      timeoutId.current = setTimeout(() => setDelay(delay - 1000), 1000);
    }
    return () => clearTimeout(timeoutId.current);
  }, [delay, to, redirect]);

  return {
    remaining: Math.ceil(delay / 1000),
  };
};
